import { render, staticRenderFns } from "./strategyDetail.vue?vue&type=template&id=5444c406"
import script from "./strategyDetail.vue?vue&type=script&lang=js"
export * from "./strategyDetail.vue?vue&type=script&lang=js"
import style0 from "./strategyDetail.vue?vue&type=style&index=0&id=5444c406&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports